import React from 'react';
import { Card, CardContent } from './ui/card';
import { Skeleton } from './ui/skeleton';
import { Separator } from './ui/separator';

const CurrentOffersCard = ({ offers, loading = false }) => {
  const formatValue = (value, type = 'percentage') => {
    if (loading || value === null || value === undefined) {
      return <Skeleton className="w-16 h-6 inline-block" />;
    }
    switch (type) {
      case 'currency': return `$${value}`;
      case 'large_currency': return `$${value.toLocaleString()}`;
      case 'status': return value;
      default: return `${value}%`;
    }
  };

  const offerItems = [
    { label: 'Rakeback', value: offers?.rakeback, color: 'text-primary-500' },
    { label: 'Cashback', value: offers?.cashback, color: 'text-primary-400' },
    { label: 'Reload', value: offers?.reload, type: 'currency', color: 'text-brand-blue' },
    { label: 'JPM', value: offers?.jpm, type: 'status', color: 'text-brand-green' },
    { label: 'BMS', value: offers?.bms, type: 'currency', color: 'text-brand-yellow' },
    { label: 'Piggy Cash', value: offers?.playzCash, type: 'large_currency', color: 'text-brand-purple' },
  ];

  return (
    <Card className="h-fit sticky top-5">
      <CardContent className="p-5">
        <h3 className="text-center font-bold text-primary-500 mb-4">Current Offers</h3>
        <div>
          {offerItems.map((item, index) => (
            <React.Fragment key={item.label}>
              <div className="flex justify-between items-center py-2.5">
                <span className="font-medium text-ink">{item.label}:</span>
                <span className={`font-bold text-base ${item.color}`}>
                  {formatValue(item.value, item.type)}
                </span>
              </div>
              {index < offerItems.length - 1 && <Separator />}
            </React.Fragment>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default CurrentOffersCard;
